import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Alert, Box, Container, Snackbar } from "@mui/material";
import fazaaLogo from "../assets/logo.png";
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { setSnackMessage, setSsoToken } from "../utils/globalSlice";
import SecureLS from "secure-ls";
import { useDispatch, useSelector } from "react-redux";
import { scrollToTop } from "../utils/scrollUtils";
import FloatingActions from "./FloatingActions";

const Layout = ({ children }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const snackOpen = useSelector((state) => state.global.showSnakBar);
  const snackBarMessage = useSelector((state) => state.global.snackMessage);
  const snackBarVariant = useSelector((state) => state.global.snackVariant);

  const ls = new SecureLS({ encodingType: "aes" });

  const dispatch = useDispatch();

  //sets the token in store and localstorage
  //also removes token from url after page load
  useEffect(() => {
    if (searchParams.has("token")) {
      const ssoToken = searchParams.get("token");
      if (ssoToken) {
        dispatch(setSsoToken(ssoToken));
        ls.set("ssoToken", ssoToken);
        searchParams.delete("token");
        const newParams = {};
        searchParams.forEach((value, key) => {
          newParams[key] = value;
        });
        navigate(
          {
            search: createSearchParams(newParams).toString(),
          },
          { replace: true }
        );
      }
    }
  }, []);

  //handles page scroll to top on page load based on change in pathname
  useEffect(() => {
    scrollToTop();
  }, [location.pathname]);

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setSnackMessage({ open: false, message: "", variant: "" }));
  };

  return (
    <>
      <Container maxWidth="100%" disableGutters>
        <Header image={fazaaLogo} altTxt="Fazaa Used Cars" />
      </Container>
      {children}

      <Container
        maxWidth="100%"
        sx={{ backgroundColor: "bgColor.main", padding: "1rem 0" }}
      >
        <Footer />
      </Container>
      <Snackbar
        open={snackOpen}
        autoHideDuration={3000}
        onClose={handleSnackClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackBarVariant}
          variant="filled"
          sx={{ width: "100%" }}
          onClose={handleSnackClose}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Layout;
